module.exports = __webpack_public_path__ + "static/media/three-flavors-pizza.9ccbed2e.svg";